// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-pagination-container {
    margin-top: 22px;
}

.pagination {
    margin-bottom: 0px !important;
}

.page-link.active,
.active>.page-link {
    color: #1D1D1D !important;
    border: none;
    background-color: none !important;
}

.active>.page-link {
    background: none !important;
    border: none !important
}

.page-item:last-child .page-link {
    padding: 0px;
    height: 100%;
    display: flex;
    align-items: center;
}

.page-item:first-child .page-link.previous {
    background-color: none !important;
    padding: 0px;
    height: 100%;
    display: flex;
    align-items: center;
}

.page-item:first-child .page-link.previous img {
    width: 9px;
    height: 9px;
    display: block !important;
    margin-right: 5px;
    /* transform: rotate(-180deg);  */
    margin-top: 2.2px;
}

.next-button img {
    width: 9px;
    height: 9px;
    margin-left: 5px !important;
    margin-top: 2.2px;
}

.page-link {
    color: var(--purple) !important;
    border: none !important;
    font-family: var(--Inter-SemiBold600);
    font-size: 16px;
    line-height: 18px;
    border-color: none !important;
    box-shadow: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/modals/pagination/Pagination.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;IAEI,yBAAyB;IACzB,YAAY;IACZ,iCAAiC;AACrC;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,iCAAiC;IACjC,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;IAC/B,uBAAuB;IACvB,qCAAqC;IACrC,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,2BAA2B;AAC/B","sourcesContent":[".table-pagination-container {\n    margin-top: 22px;\n}\n\n.pagination {\n    margin-bottom: 0px !important;\n}\n\n.page-link.active,\n.active>.page-link {\n    color: #1D1D1D !important;\n    border: none;\n    background-color: none !important;\n}\n\n.active>.page-link {\n    background: none !important;\n    border: none !important\n}\n\n.page-item:last-child .page-link {\n    padding: 0px;\n    height: 100%;\n    display: flex;\n    align-items: center;\n}\n\n.page-item:first-child .page-link.previous {\n    background-color: none !important;\n    padding: 0px;\n    height: 100%;\n    display: flex;\n    align-items: center;\n}\n\n.page-item:first-child .page-link.previous img {\n    width: 9px;\n    height: 9px;\n    display: block !important;\n    margin-right: 5px;\n    /* transform: rotate(-180deg);  */\n    margin-top: 2.2px;\n}\n\n.next-button img {\n    width: 9px;\n    height: 9px;\n    margin-left: 5px !important;\n    margin-top: 2.2px;\n}\n\n.page-link {\n    color: var(--purple) !important;\n    border: none !important;\n    font-family: var(--Inter-SemiBold600);\n    font-size: 16px;\n    line-height: 18px;\n    border-color: none !important;\n    box-shadow: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
